<template>
  <div class="tourist-town-container">
    <div class="banner-container">
      <img
        src="../../../assets/images/touristTown/banner.jpg"
      />
    </div>
    <p class="section-title-line">
      <span>使命</span>
    </p>
    <div class="section-container intro-box-content">
      <p>
        <strong><span style="color: rgb(0, 176, 80)">乡 村 振 兴</span></strong>
      </p>
      <p>
        <span style="font-size: 20px; color: rgb(63, 63, 63)"
          ><strong><span>国家伟大的战略</span></strong
          ><span>，</span><strong><span>农村的改革开放</span></strong
          ><span>。</span></span
        >
      </p>
      <p><br /></p>
      <p>
        新希望集团发展于田间地头，一二三产全覆盖全涉及，是扎根民生的龙头企业。围绕总书记“产业兴旺、生态宜
      </p>
      <p>
        居、乡风文明、治理有效、生活富裕”20个字方针，我们一定是乡村振兴中的探索者。在积极投身参与中，我们
      </p>
      <p>
        应当着力发挥产业集群优势，让城市资本到农村去，真正实现产城一体的有机融合。
      </p>
      <p><br /></p>
      <p><br /></p>
      <p>
        <strong><span style="color: rgb(0, 176, 80)">模 式 创 新</span></strong>
      </p>
      <p>
        <span style="font-size: 20px; color: rgb(63, 63, 63)"
          ><strong><span>开创</span></strong
          ><span>“</span><strong><span>三产融合</span></strong
          ><span>”</span><strong><span>和</span></strong
          ><span>“</span><strong><span>三生融合</span></strong
          ><span>”</span><strong><span>为一体的新型乡村振兴模式</span></strong
          ><span>。</span></span
        >
      </p>
      <p><br /></p>
      <p>
        新希望地产从文旅、运动、医疗、康养领域进行探索，发展现代农业、乡村旅游、康养结合、特色产业等文旅
      </p>
      <p>
        项目。
        重点布局京津冀、长三角、成渝、珠三角四大城市群，重点深耕一二线热点城市周边1小时车程范围内
      </p>
      <p>区域，发挥集团优势做好产城结合，并以项目精雕为理念深耕发展。</p>
      <p><br /></p>
      <p><br /></p>
      <p>
        <strong><span style="color: rgb(0, 176, 80)">坚 守 使 命</span></strong>
      </p>
      <p>
        <span style="font-size: 20px; color: rgb(63, 63, 63)"
          ><strong>农村稳则天下安</strong
          >，<strong>农业兴则基础牢</strong>，<strong>农民富则国家盛</strong>。</span
        >
      </p>
      <p><br /></p>
      <p>……</p>
    </div>
    <div class="section-container mt50">
      <el-row :gutter="20">
        <el-col
          :span="12"
          v-for="(item, index) in list"
          :key="item.name + index"
          class="wow animate__slideInUp"
          data-wow-duration="500ms"
        >
          <div class="top-box">
            <img :src="item.image" alt="" />
          </div>
          <div class="bottom-box">
            <div class="bottom-left">
              <p class="name" v-for="(el, index) in item.name" :key="index">{{ el }}</p>
              <p class="tip">{{ item.tip }}</p>
            </div>
            <div class="bottom-right">
              <p>项目概况</p>
              <div class="desc">
                <p
                  v-for="(ele, i) in item.desc || []"
                  :key="i"
                  v-html="ele"
                ></p>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
export default {
  name: "TouristTownPage",
  data() {
    return {
      list: [
        {
          name: ["成都", "东进新希望", "运动休闲度假区"],
          desc: [
            "项目位于简阳贾家，占地面积12000亩，以运动休闲为主题，以亲子家庭等大众人群为核心客群，扩展休闲内涵、提升休闲品质，打造集运动娱乐、运动田园、亲子乐园、运动养生、运动挑战、文化演艺、运动双创等为一体的休闲运动国家级旅游度假区和城市新名片。",
          ],
          tip: "体育小镇",
          image: require('../../../assets/images/touristTown/proj1.jpg')
        },
        {
          name: ["苏州戗港", "国际康养项目"],
          desc: [
            "吴江戗港国际康养项目占地面积2465亩，将结合国际养生旅游产业发展经验、国内康养旅游产业需求，打造成为全龄段、全时全季、具有本地特色的田园养生综合体，集农、禅、医、养于一体的康养项目。",
          ],
          tip: "康养小镇",
          image: require('../../../assets/images/touristTown/proj2.jpg')
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$wow.init();
    })
  }
};
</script>
<style lang="scss" scoped>
.tourist-town-container {
  .intro-box-content {
    strong {
      font-weight: 700;
    }
  }

  .mt50 {
    margin-top: 50px;
  }

  .top-box {
    overflow: hidden;
    width: 100%;
    > img {
      display: block;
      max-width: 100%;
      height: auto;
    }
  }

  .bottom-box {
    height: 235px;
    overflow: hidden;
    background-color: #ecedee;
    display: flex;
    .bottom-left {
      height: 100%;
      width: 45%;
      padding-top: 23px;
      padding-left: 23px;
      position: relative;
    }

    .bottom-right {
      height: 100%;
      color: #565c61;
      box-sizing: border-box;
      padding-top: 23px;
      width: 55%;
      padding-right: 23px;

      > p {
        line-height: 40px;
        font-size: 14px;
      }
    }
  }

  .name {
    text-align: justify;
    font-size: 20px;
    line-height: 30px;
    color: #008048;
  }

  .tip {
    position: absolute;
    border-radius: 1px;
    padding: 5px 15px;
    border: 1px solid #565c61;
    top: 150px;
    color: #565c61;
    font-size: 13px;
  }

  .desc {
    > p {
      margin-bottom: 8px;
      line-height: 25px;
      font-size: 13px;
      text-align: justify;
      word-break: break-all;
    }
  }
}
</style>
